import React from "react";
import DropdownProfileMenu from "./ProfileOptionsDropdown";
import { useAuth } from "../Context/AuthContext.js";

function NavbarTop() {
  const Auth = useAuth();
  const userData = Auth.getSessionData() ?? {};

  const { vc_partner, vc_usertype, vc_displayname } = userData;
  const partnerLabel =
    vc_partner && vc_partner !== "null" ? `${vc_partner} | ` : "";

  return (
    <header className="flex items-center justify-between px-6 py-1.5 bg-white">
      <span className="text-sm font-medium text-gray-600">
        {partnerLabel}
        {vc_usertype}
      </span>

      <div className="flex items-center gap-4">
        <span className="text-sm font-medium text-gray-700">
          {vc_displayname}
        </span>
        <DropdownProfileMenu />
      </div>
    </header>
  );
}

export default NavbarTop;
